<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item active">Проекты</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<div class="float-end d-flex" v-if="authModel.isAdmin()">
				<router-link :to="{path: '/projects/add'}" class="btn btn-primary d-flex align-items-center">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
						<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
					</svg>
					<span class="d-none d-md-inline-block ms-2">Добавить проект</span>
				</router-link>
			</div>
			<h5>Проекты</h5>
			<div class="text-muted">Управление проектами</div>
		</div>
		<filter-bar 
			v-model:search="search" 
			v-model:limit="limit" 
			:loading="loading" 
		>
			<template v-slot:default="{ disabled }">
				<div class="btn-group w-100" role="group" aria-label="Basic outlined example">
					<button
						type="button"
						class="btn d-flex align-items-center justify-content-center px-2"
						:class="filterRepo === 'hg' ? 'btn-secondary' : 'btn-outline-secondary'"
						:disabled="disabled"
						title="Mercurial HG"
						v-tippy="{placement: 'top'}"
						@click="filterRepo = filterRepo === 'hg' ? '' : 'hg'"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
							<path d="M10.66 17c.22.84.08 1.74-.38 2.48a3.174 3.174 0 0 1-5.9-.62c-.22-.84-.08-1.74.38-2.48a3.174 3.174 0 0 1 5.9.62m-5.14-4.46c.51-.56.62-1.48.45-2A2.07 2.07 0 0 0 3.42 9.1c-.58.16-1.05.56-1.31 1.1-.62.97-.33 2.25.64 2.86.92.59 2.14.36 2.78-.52M12.1 2.08c-2.63.33-4.33 1.53-5.12 3.03-1.65 2.68-.26 6.44 4 7.65 5.58 1.58 1.15 5.12 1.28 7.48s4.85 3.21 8.57-2.98c.07-.12.14-.24.2-.36 3.53-6.08-.89-15.81-8.93-14.81"/>
						</svg>
					</button>
					<button
						type="button"
						class="btn d-flex align-items-center justify-content-center px-2"
						:class="filterRepo === 'git' ? 'btn-secondary' : 'btn-outline-secondary'"
						:disabled="disabled"
						title="Git"
						v-tippy="{placement: 'top'}"
						@click="filterRepo = filterRepo === 'git'  ? '' : 'git'"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
							<path d="M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12A2,2 0 0,0 17,14A2,2 0 0,0 19,12A2,2 0 0,0 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z" />
						</svg>
					</button>
				</div>
			</template>
		</filter-bar>
		<div class="table-responsive">
			<table class="table table-hover table-bordered">
				<thead>
					<tr>
						<th style="width: 38px;" class="text-center">Иконка</th>
						<th>Название проекта</th>
						<th width="25%">Группы</th>
						<th width="25%">Пользователи</th>
						<th style="width: 80px;" class="text-center">Системы</th>
						<th style="width: 125px;" class="text-center" v-if="authModel.isAdmin()">Операции</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="project in projects" :key="project.id">
						<td class="align-middle text-center">
							<image-with-placeholder
								:src="getAvatar(project)"
								class="mw-100 ratio ratio-1x1"
								height="100%"
								skeleton="shimmer"
								alt="icon"
							/>
						</td>
						<td class="align-middle">
							<div>{{ project.name }}</div>
							<div>
								<code>{{ project.apiname }}</code>
							</div>
						</td>
						<td class="align-middle">
							<span class="badge text-bg-primary font-monospace me-1">@all</span>
							<router-link
								:to="{path: '/users/groups/' + group.id}"
								class="badge text-bg-dark text-decoration-none font-monospace me-1"
								v-for="group in project.groups" :key="group.id"
							>@{{ group.name }}</router-link>
						</td>
						<td class="align-middle">
							<router-link
								:to="{path: '/users/' + user.id}"
								class="badge fs-6 text-danger border px-2 py-1 rounded text-decoration-none font-monospace me-1 mb-1"
								v-for="user in project.users" :key="user.id"
							>{{ user.login }}</router-link>
						</td>
						<td class="align-middle">
							<div class="d-grid gap-2 d-md-flex align-items-center justify-content-md-center">
								<a
									:href="`/${project.repotype}/${project.apiname}`"
									class="btn btn-secondary d-flex align-items-center justify-content-center"
									:title="project.repotype == 'hg' ? 'Mercurial (HG)' : 'Git'"
									v-tippy="{placement: 'top'}"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path v-if="project.repotype == 'hg'" d="M10.66 17c.22.84.08 1.74-.38 2.48a3.174 3.174 0 0 1-5.9-.62c-.22-.84-.08-1.74.38-2.48a3.174 3.174 0 0 1 5.9.62m-5.14-4.46c.51-.56.62-1.48.45-2A2.07 2.07 0 0 0 3.42 9.1c-.58.16-1.05.56-1.31 1.1-.62.97-.33 2.25.64 2.86.92.59 2.14.36 2.78-.52M12.1 2.08c-2.63.33-4.33 1.53-5.12 3.03-1.65 2.68-.26 6.44 4 7.65 5.58 1.58 1.15 5.12 1.28 7.48s4.85 3.21 8.57-2.98c.07-.12.14-.24.2-.36 3.53-6.08-.89-15.81-8.93-14.81"/>
										<path v-if="project.repotype == 'git'" d="M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12A2,2 0 0,0 17,14A2,2 0 0,0 19,12A2,2 0 0,0 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z" />
									</svg>
								</a>
							</div>
						</td>
						<td class="align-middle" v-if="authModel.isAdmin()">
							<div class="d-grid gap-2 d-md-flex align-items-center justify-content-md-center">
								<router-link
									:to="{path: '/projects/' + project.id}"
									class="btn btn-primary d-flex align-items-center justify-content-center"
									:disabled="project.loading"
									title="Изменить"
									v-tippy="{placement: 'top'}"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
									</svg>
								</router-link>
								<button
									type="button"
									class="btn btn-danger d-flex align-items-center justify-content-center"
									title="Удалить"
									v-tippy="{placement: 'top'}"
									:disabled="project.loading"
									@click="deleteProject(project.id)"
								>
									<span v-if="project.loading" class="spinner-border spinner-border-sm" style="width: 24px; height: 24px;"></span>
									<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
									</svg>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">Всего проектов: {{ projects_count }}</div>
			<pagination 
				v-model="page" 
				:total="projects_count" 
				:limit="limit" 
				:loading="loading"
				@change="loadData"
			/>
		</div>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import FilterBar from '@/components/FilterBar.vue';
import Pagination from '@/components/Pagination.vue';
import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Проекты | SKV'});
	},
	data: () => ({
		projects: [],
		projects_count: 0,
		
		search: '',
		filterRepo: '',
		page: 1,
		limit: 25,
		loading: true,
		debounceTimeout: null,
	}),
	watch: {
		// Если пользователь нажал "Назад" или изменил URL, подгружаем данные заново
		'$route.query': {
			handler(newQuery) {
				this.search = newQuery.search || "";
				this.filterRepo = newQuery.filterRepo || "";
				this.page = parseInt(newQuery.page) || 1;
				// Вызываем загрузку без push в роутер (чтобы не зациклиться)
				this.fetchProjects(); 
			},
			immediate: true,
		},
		filterRepo() {
			this.page = 1;
			this.fetchProjects();
		},
		search(newVal) {
			this.page = 1; // При поиске всегда сбрасываем на 1 страницу
			this.debouncedSearch();
		},
		limit(newVal) {
			this.page = 1;
			this.fetchProjects();
		},
	},
	methods: {
		getAvatar(project) {
			if (!project?.icon) return "/assets/images/noimage1.png";
			return `/files/projects/${project.repotype}/${project.icon}`;
		},
		
		async fetchProjects() {
			this.loading = true;
			const params = {
				search: this.search,
				filterRepo: this.filterRepo,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetProjects(params);
			if (ret.success) {
				this.projects = ret.list.map(project => ({
					...project,
					loading: false,
				}));
				this.projects_count = ret.count;
			} else {
				this.$toast.error(ret.message);
			}
			this.loading = false;
		},
		debouncedSearch() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(() => {
				this.loadData();
			}, 500);
		},
		async loadData() {
			// Мы просто меняем URL, а Watcher сам увидит это и вызовет fetchUsers
			await this.$router.push({
				query: { 
					...this.$route.query, 
					search: this.search || undefined, 
					filterRepo: this.filterRepo || undefined, 
					page: this.page,
				},
			}).catch(() => {});
		},
		
		deleteProject(id) {
			const project = this.projects.find(p => p.id === id);
			if (!project) return;
			
			useModal({
				component: BootstrapConfirmModal,
				attrs: {
					title: "Удаление проекта",
					centered: true,
					confirmText: "Удалить проект",
					confirmColor: "danger",
					onConfirm: async () => {
						project.loading = true;
						try {
							const result = await this.appModel.doDeleteProject(id);
							if (result.success) {
								await this.appModel.refreshCounts();
								
								this.fetchProjects();
							} else {
								this.$toast.error(result.message);
							}
						} finally {
							project.loading = false;
						}
					},
				},
				slots: {
					default: `Вы уверены, что хотите безвозвратно удалить проект "${project.name} (${project.apiname})"?`,
				},
			}).open();
		},
	},
	components: {
		FilterBar,
		Pagination,
		ImageWithPlaceholder,
	},
};
</script>
